var _       = require('underscore');
var $       = require('jquery');
var ui_templates = require("ui-templates");
var Core        = ui_templates.Core;

/**
 * Creates a sidebar group item
 *
 * @class
 */

class SidebarPackageGeneratorListItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                "name": '',
                "thumbnail": '',
                "theme": 'dark'
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__sidebar__package__generator__list__item js-editor__sidebar__package__generator__list__item <%- theme %>">
                <div class="editor__sidebar__package__generator__list__item__thumbnail">
                    <img src="<%- thumbnail %>">
                </div>
                <div class="editor__sidebar__package__generator__list__item__title <%- theme %>"><%- name %></div>
            </div>
        `;

        super.render();

        this.$el.on('click', this._itemClicked);
    }

    _itemClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SidebarPackageGeneratorListItem:clicked', e);
    }
}

module.exports = SidebarPackageGeneratorListItem;
